// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XKYWhcMBzIvWkPXfxFjS {
  display: block;
  position: absolute;
  bottom: -1%;
  border-radius: unset;
  z-index: -2;
  left: calc(var(--most-played-num-image-width) * -0.85);
  width: var(--most-played-num-image-width);
  height: var(--most-played-num-image-height);
}
.XKYWhcMBzIvWkPXfxFjS img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
/* we want each card to push the previous card around 1/4th of the image's width */
.edD9zUlhiXqdBXcZc0Uw.Hh0s_fYL1zxEWsSbzFrR {
  margin-left: calc(var(--most-played-num-image-width) / 2.8);
}
/* we want specific spacing for double digits */
.edD9zUlhiXqdBXcZc0Uw.Hh0s_fYL1zxEWsSbzFrR:nth-child(10) {
  margin-left: calc(var(--most-played-num-image-width) / 1.35);
}
/* 11 is handled seperately */
.edD9zUlhiXqdBXcZc0Uw.Hh0s_fYL1zxEWsSbzFrR:nth-child(n + 12) {
  margin-left: calc(var(--most-played-num-image-width) / 1.4);
}
.edD9zUlhiXqdBXcZc0Uw.Hh0s_fYL1zxEWsSbzFrR:nth-child(n + 20) {
  margin-left: calc(var(--most-played-num-image-width) / 1.15);
}
/* 
  Exceptions
  we want specific spacing for the digit 1 at the end of a number
*/
.edD9zUlhiXqdBXcZc0Uw:first-child {
  margin-left: 10px;
}
.edD9zUlhiXqdBXcZc0Uw.Hh0s_fYL1zxEWsSbzFrR:nth-child(1) .XKYWhcMBzIvWkPXfxFjS {
  left: calc(var(--most-played-num-image-width) * -0.85 + 1px);
}
.edD9zUlhiXqdBXcZc0Uw.Hh0s_fYL1zxEWsSbzFrR:nth-child(11) {
  margin-left: calc(var(--most-played-num-image-width) / 1.55);
}
.edD9zUlhiXqdBXcZc0Uw.Hh0s_fYL1zxEWsSbzFrR:nth-child(11) .XKYWhcMBzIvWkPXfxFjS {
  left: calc(var(--most-played-num-image-width) * -0.85 + 1px);
}
.edD9zUlhiXqdBXcZc0Uw.Hh0s_fYL1zxEWsSbzFrR:nth-child(21) {
  margin-left: calc(var(--most-played-num-image-width) / 1.22);
}
.edD9zUlhiXqdBXcZc0Uw.Hh0s_fYL1zxEWsSbzFrR:nth-child(21) .XKYWhcMBzIvWkPXfxFjS {
  left: calc(var(--most-played-num-image-width) * -0.85 + 1px);
}
@media (min-width: 576px) {
  .edD9zUlhiXqdBXcZc0Uw:first-child {
    margin-left: 12px;
  }
}
@media (min-width: 1026px) {
  .edD9zUlhiXqdBXcZc0Uw:first-child {
    margin-left: 36px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/games/components/GameCard/components/TopGamesNumbers/TopGamesNumbers.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,sDAAsD;EACtD,yCAAyC;EACzC,2CAA2C;AAC7C;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA,kFAAkF;AAClF;EACE,2DAA2D;AAC7D;AACA,+CAA+C;AAC/C;EACE,4DAA4D;AAC9D;AACA,6BAA6B;AAC7B;EACE,2DAA2D;AAC7D;AACA;EACE,4DAA4D;AAC9D;AACA;;;CAGC;AACD;EACE,iBAAiB;AACnB;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,4DAA4D;AAC9D;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".TopGamesNumberContainer {\n  display: block;\n  position: absolute;\n  bottom: -1%;\n  border-radius: unset;\n  z-index: -2;\n  left: calc(var(--most-played-num-image-width) * -0.85);\n  width: var(--most-played-num-image-width);\n  height: var(--most-played-num-image-height);\n}\n.TopGamesNumberContainer img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n/* we want each card to push the previous card around 1/4th of the image's width */\n.gameContainer.multi {\n  margin-left: calc(var(--most-played-num-image-width) / 2.8);\n}\n/* we want specific spacing for double digits */\n.gameContainer.multi:nth-child(10) {\n  margin-left: calc(var(--most-played-num-image-width) / 1.35);\n}\n/* 11 is handled seperately */\n.gameContainer.multi:nth-child(n + 12) {\n  margin-left: calc(var(--most-played-num-image-width) / 1.4);\n}\n.gameContainer.multi:nth-child(n + 20) {\n  margin-left: calc(var(--most-played-num-image-width) / 1.15);\n}\n/* \n  Exceptions\n  we want specific spacing for the digit 1 at the end of a number\n*/\n.gameContainer:first-child {\n  margin-left: 10px;\n}\n.gameContainer.multi:nth-child(1) .TopGamesNumberContainer {\n  left: calc(var(--most-played-num-image-width) * -0.85 + 1px);\n}\n.gameContainer.multi:nth-child(11) {\n  margin-left: calc(var(--most-played-num-image-width) / 1.55);\n}\n.gameContainer.multi:nth-child(11) .TopGamesNumberContainer {\n  left: calc(var(--most-played-num-image-width) * -0.85 + 1px);\n}\n.gameContainer.multi:nth-child(21) {\n  margin-left: calc(var(--most-played-num-image-width) / 1.22);\n}\n.gameContainer.multi:nth-child(21) .TopGamesNumberContainer {\n  left: calc(var(--most-played-num-image-width) * -0.85 + 1px);\n}\n@media (min-width: 576px) {\n  .gameContainer:first-child {\n    margin-left: 12px;\n  }\n}\n@media (min-width: 1026px) {\n  .gameContainer:first-child {\n    margin-left: 36px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TopGamesNumberContainer": `XKYWhcMBzIvWkPXfxFjS`,
	"gameContainer": `edD9zUlhiXqdBXcZc0Uw`,
	"multi": `Hh0s_fYL1zxEWsSbzFrR`
};
export default ___CSS_LOADER_EXPORT___;
